var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{staticClass:"text-uppercase",attrs:{"id":"language-dropdown","right":"","text":_vm.$language.current}},_vm._l((_vm.$language.available),function(_,key){return _c('b-dropdown-item-button',{key:key,on:{"click":function($event){return _vm.langChanged(key)}}},[_vm._v(" "+_vm._s(key.toUpperCase())+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }